import { HealthConditionContainer } from './HealthConditionsContainer';
import { useParams } from 'react-router-dom';
import {
  useGetHealthConnectionDetailV2,
  useGetDiseaseRiskDetailV2,
} from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { useIsProUser } from '@/hooks/useIsProUser';

const HealthConnectionCondition = ({ conditionName }: { conditionName: string }) => {
  const { data: conditionDetail = {}, isLoading } = useGetHealthConnectionDetailV2(conditionName);
  return <HealthConditionContainer condition={conditionDetail} isLoading={isLoading} />;
};

const DiseaseRiskCondition = ({ conditionName }: { conditionName: string }) => {
  const { data: conditionDetail = {}, isLoading } = useGetDiseaseRiskDetailV2(conditionName);
  return (
    <HealthConditionContainer condition={conditionDetail} isLoading={isLoading} isProUser />
  );
};

export const HealthConditionsPage = () => {
  const { condition: conditionName } = useParams();
  const isProUser = useIsProUser();
  return (
    <div className="dark bg-black h-full w-full">
      {isProUser ? (
        <DiseaseRiskCondition conditionName={conditionName || ''} />
      ) : (
        <HealthConnectionCondition conditionName={conditionName || ''} />
      )}
    </div>
  );
};
